<app-text-tooltip class="youth-info-center-tooltip">
  <app-chip element>Opérateur CEJ</app-chip>
  <div modal-content class="youth-info-center-tooltip__modal">
    Opérateur en charge du Contrat Engagement Jeune.
    <a [routerLink]="['/', FeaturesRoutingEnum.CEJ]" class="link--primary">En savoir plus</a>
  </div>
</app-text-tooltip>
